"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserLogEntryProcessorProvider = void 0;
const pino_processor_1 = require("../base/pino-processor");
class BrowserLogEntryProcessorProvider {
    create(options) {
        // The browser version of pino doesn't have the same API as the node version when using import.
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const pino = require('pino');
        const level = (options === null || options === void 0 ? void 0 : options.level) || 'info';
        return new pino_processor_1.PinoLogEntryProcessor(pino({
            level,
            enabled: level !== 'silent',
        }));
    }
}
exports.BrowserLogEntryProcessorProvider = BrowserLogEntryProcessorProvider;
//# sourceMappingURL=processor.js.map